import { ME_QUERY } from '@/shared/api/graphql/members/documents/me.document';
import type { TMeOutput } from '@/shared/api/graphql/members/validators/me.validator';
import { graphqlApiCaller } from '@/shared/helpers/api.helper';

export const getMe = async () => {
  const { me } = await graphqlApiCaller<TMeOutput>(ME_QUERY);
  if (!me.ok) throw new Error(me.error.message, { cause: me.error.code });
  return me.data;
};
